import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/outfit/300.css';
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import '@fontsource/outfit/700.css';
import '@fontsource/outfit/800.css';
import '@fontsource/outfit/900.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import ErrorBoundary from './components/common/ErrorBoundary';
import api from './lib/axios';
import axios from 'axios';
import { getActiveHospitalId } from './lib/constants';

// Global Hospital Context Interceptor for all native Axios requests
axios.interceptors.request.use((config) => {
  const currentHospitalId = getActiveHospitalId();

  // 1. Attach active hospital_id to query string parameters on ALL GET, POST, PUT, DELETE calls
  config.params = {
    hospital_id: currentHospitalId,
    ...config.params
  };

  // 2. Attach active hospital_id to JSON payloads
  if (config.data && typeof config.data === 'object' && !(config.data instanceof FormData)) {
    if (config.data.hospital_id === undefined) {
      config.data.hospital_id = currentHospitalId;
    }
  }

  // 3. Attach active hospital_id to FormData payloads
  if (config.data instanceof FormData) {
    if (!config.data.has('hospital_id')) {
      config.data.append('hospital_id', String(currentHospitalId));
    }
  }

  return config;
}, (error) => Promise.reject(error));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

if (!Object.hasOwn) {
  Object.hasOwn = function (obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename={process.env.PUBLIC_URL || (window.location.pathname.startsWith('/demo/') ? window.location.pathname.split('/').slice(0, 3).join('/') : '')}>
          <AuthProvider>
            <NotificationProvider>
              <App />
            </NotificationProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
